(function () {
  function render() {
    if (!window.swellAPI || !swellAPI.getCustomerDetails) return;

    var t = swellAPI.getCustomerDetails();
    if (!t) return;

    var label = t.pointsBalance > 1 ? "Proud Points" : "Proud Point";
    var html = t.vipTier && t.vipTier.name
      ? (t.vipTier.name + " | " + t.pointsBalance + " " + label)
      : (t.pointsBalance + " " + label);

    // Support BOTH hooks so you can standardize gradually
    var selectors = [".js-points-customer", ".js-points-balance"];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.innerHTML = html;
      });
    });
  }

  // Runs when Swell is ready
  document.addEventListener("swell:setup", render);

  // Also run if the nav opens later (some themes mount drawers late)
  document.addEventListener("DOMContentLoaded", function () {
    // in case swell:setup already fired before this script loads
    setTimeout(render, 0);
  });
})();
